import { api } from '@/api/client';
import { SchemaForm, SchemaFormValues } from '@/features/SchemaForm';
import { InquiryFormTemplate } from '@/features/SchemaForm/templates/InquiryFormTemplate';
import { useInquiryContactDefaults } from '@/hooks/useInquiryContactDefaults';
import { inquirySellPropertySchema } from '@mr-website/schemas';

const DiscussYourPropertyForm = () => {
  const { defaultValuesCallback } = useInquiryContactDefaults();

  const handleSubmit = async (values: SchemaFormValues) => {
    await api.post('/inquiry/sell-property', values);
  };

  return (
    <SchemaForm
      zodSchema={inquirySellPropertySchema}
      defaultValuesCallback={defaultValuesCallback}
      template={
        <InquiryFormTemplate
          title="To Discuss Your Property"
          description="All fields are required. We will contact you within 24 hours to discuss the sale of your property."
          successMessage="A Real Estate Advisor will be in touch with you shortly."
        />
      }
      variant="stacked"
      onSubmit={handleSubmit}
      enableTurnstile
    />
  );
};

export { DiscussYourPropertyForm };
